import {GameActionCreators} from "../../../store/reducers/game/action-creators";
import {SoundsService} from "../../SoundsService";
import ServerStateDispatcher from "../ServerStateDispatcher";
import {store} from "../../../store";


export default class CpuPlayedCard {

    static async show(ServerState, dispatch, isPlayer = false) {

        const state = store.getState();

        if (state.game.phase === 'end_game') {
            return;
        }

        dispatch(GameActionCreators.setCpuPlayedCard({
            card: ServerState.card,
            target: ServerState.target
        }));

        if (ServerState.result !== undefined && ServerState.result !== null) {

            if (ServerState?.double_state !== true) {
                ServerState.result = [ServerState.result];
            }

            for (let i = 0; i < Object.keys(ServerState.result).length; i++) {
                await ServerStateDispatcher.dispatchState({
                    sign: 'local_played_card_result',
                    state: ServerState.result[i]
                }, dispatch);
            }
        }

        SoundsService.playCard(ServerState.card);

        let timeout = 2000;


        await new Promise(r => setTimeout(r, timeout));

        dispatch(GameActionCreators.setCpuPlayedCard({
            card: null,
            target: null
        }));
    }
}
